import React from 'react'
import { Bar} from 'react-chartjs-2';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider
} from '@mui/material';

const PeriodicDailySales =({avgItemTr, dayShow,weekShow, monthShow, threeMonthsShow, totalSales}) => {
  const options = {
    animation: false,
    cutoutPercentage: 70,
    layout: { padding: 0 },
    legend: {
      display: true
    },
    maintainAspectRatio: false,
    responsive: true

  };

  return (
    <Card
      sx={{
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
      }}
    >
      <CardHeader
        title="Total Daily Sales"
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
      >
      </CardHeader>

      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 500,
            position: 'relative'
          }}
        >

          <Bar
            data={totalSales.durationSales}
            options={options}
          />
        </Box>

      </CardContent>
    </Card>
  );
};

export default PeriodicDailySales;
